import { PATH } from './constants/router';
import React from 'react';
const BookingHistory = React.lazy(() => import('./page/BookingHistory/index'))
const BookingDetail = React.lazy(() => import('./page/BookingDetail/index'))
const UpdateBookingDetail = React.lazy(() => import('./page/BookingDetail/UpdateBookingDetail'))
const IframeView = React.lazy(() => import('./page/IframeView'))
const OrderPayment = React.lazy(() => import('./page/OrderPayment/index'))
const PaymentPolicy = React.lazy(() => import('./page/PaymentPolicy/index'))

export const ROUTERS = {
    // mini app
    homeZalo: {
        path: PATH.HOME,
        component: OrderPayment,
        isZaloApp: 1
    },
    bookingDetailZalo: {
        path: PATH.BOOKING_DETAIL,
        component: BookingDetail,
        isZaloApp: 1
    },
    bookingDetailNoIdZalo: {
        path: PATH.BOOKING_DETAIL_NO_ID,
        component: BookingDetail,
        isZaloApp: 1
    },
    bookingUpdateZalo: {
        path: PATH.BOOKING_UPDATE,
        component: UpdateBookingDetail,
        isZaloApp: 1
    },
    orderPaymentZalo: {
        path: PATH.SCHEDULE_PAYMENT,
        component: OrderPayment,
        isZaloApp: 1
    },
    orderPaymentNoIdZalo: {
        path: PATH.SCHEDULE_PAYMENT_NO_ID,
        component: OrderPayment,
        isZaloApp: 1
    },
    orderPaymentQrZalo: {
        path: PATH.SCHEDULE_PAYMENT_QR,
        component: OrderPayment,
        isZaloApp: 1
    },
    iframeViewZalo: {
        path: PATH.IFRAME_VIEW,
        component: IframeView,
        isZaloApp: 1
    },
    paymentPolicyZalo: {
        path: PATH.PAYMENT_POLICY,
        component: PaymentPolicy,
        isZaloApp: 1
    },

    // web
    homePageWeb: {
        path: PATH.HOME,
        component: OrderPayment,
        isZaloApp: 0,
    },
    bookingHistory: {
        path: PATH.BOOKING_HYSTORY,
        component: BookingHistory,
        isZaloApp: 0
    },
    bookingDetailWeb: {
        path: PATH.BOOKING_DETAIL,
        component: BookingDetail,
        isZaloApp: 0
    },
    bookingDetailNoId: {
        path: PATH.BOOKING_DETAIL_NO_ID,
        component: BookingDetail,
        isZaloApp: 0
    },
    bookingUpdateWeb: {
        path: PATH.BOOKING_UPDATE,
        component: UpdateBookingDetail,
        isZaloApp: 0
    },
    orderPaymentWeb: {
        path: PATH.SCHEDULE_PAYMENT,
        component: OrderPayment,
        isZaloApp: 0
    },
    orderPaymentNoIdWeb: {
        path: PATH.SCHEDULE_PAYMENT_NO_ID,
        component: OrderPayment,
        isZaloApp: 0
    },
    orderPaymentQrWeb: {
        path: PATH.SCHEDULE_PAYMENT_QR,
        component: OrderPayment,
        isZaloApp: 0
    },
    iframeViewWeb: {
        path: PATH.IFRAME_VIEW,
        component: IframeView,
        isZaloApp: 0
    },
    paymentPolicyWeb: {
        path: PATH.PAYMENT_POLICY,
        component: PaymentPolicy,
        isZaloApp: 0
    }
};
const isZaloApp = process.env.REACT_APP_ZALO_AUTH_ENABLE * 1
export const fillterRoutes = Object.entries(ROUTERS)
    .filter(([key, route]) => route.isZaloApp === isZaloApp)
    .reduce((obj, [key, route]) => {
        obj[key] = route;
        return obj;
    }, {});

